import { get } from "lodash";
import numberFormatter from "utils/numberFormatter";
import { LOAN_RATE_TYPES, INTEREST_INDEXES, LOAN_TYPES } from "@loanbossinc/component-library";

export const getSectionType = section => {
  switch (section) {
    case "senior_quote":
      return "Senior";
    case "mezz_quote":
      return "Subordinate";
    case "supplemental_quote":
      return "Supplemental";
    default:
      return "";
  }
};
export const getLoanTermYears = loan => {
  const { loanTermMonths } = loan;
  if (loanTermMonths) {
    return `${(loanTermMonths / 12).toFixed(2)} Years`;
  }

  return "N/A";
};

export const getInterestRateType = loan => get(loan, "rateTypeRef.name") || "N/A";

export const getLoanAmount = loan => numberFormatter.maskCurrency(loan.amount) || "N/A";

export const formatForCompare = loan => ({
  id: loan.id,
  status: loan.loanStatusId,
  title: `${loan["lenderCompany.name"] || get(loan, "loanCompanyBridge[0].company.name") || "N/A"} | ${getLoanTermYears(
    loan
  )} | ${getInterestRateType(loan)} | ${getLoanAmount(loan)}`
});

export const getLoanData = (props, key) => {
  if (!props.quotesByPreference[key]) {
    return [];
  }
  const loanData = props.quotesByPreference[key].data;
  if (loanData && loanData.loans) {
    return loanData.loans;
  }

  return [];
};

export const getSectionLoanData = (props, section) => getLoanData(props, section).map(formatForCompare)
/*
 * switch (tab) {
 *   case tabs.SENIOR:
 *   case tabs.SUBORDINATE:
 *     return getLoanData("comparableMezzLoans").map(formatForCompare);
 *   case tabs.SUPPLEMENTAL:
 *     return getLoanData("comparableSupplementalLoans").map(formatForCompare);
 *   default:
 *     throw new Error(`Invalid tab: ${tab}`);
 * }
 */
;

export const setAmortizationNull = quote => {
  if (quote.details) {
    quote.details.amortizationTypeId = null;
    quote.details.amortMisc = null;
  }
  if (quote.amortizationDetails) {
    quote.amortizationDetails.monthlyPrincipalReduction = null;
    quote.amortizationDetails.amortizationTerm = null;
  }
};
export const setCashManagementNull = quote => {
  if (quote.covenants) {
    quote.covenants.cashManagementMisc = null;
  }
};
export const setExtensionsNull = quote => {
  if (quote.extensionTerms) {
    quote.extensionTerms.misc = null;
  }
  quote.extensions = [];
};
export const setFeesNull = quote => {
  if (quote.closingCosts) {
    quote.closingCosts.originationFeePercent = null;
    quote.closingCosts.brokerFeePercent = null;
    quote.closingCosts.otherFeePercent = null;
  }
};
export const setFinancialCovenantsNull = quote => {
  if (quote.covenants) {
    quote.covenants.dscrTypeId = null;
    quote.covenants.dscrDebtServiceTerm = null;
    quote.covenants.dscrAmortTerm = null;
    quote.covenants.dscrFixedRate = null;
    quote.covenants.dscrTreasurySpread = null;
    quote.covenants.dscrFloatingRateSpread = null;
    quote.covenants.dscrStabilized = null;
    quote.covenants.dscrCovenants = null;
    quote.covenants.debtYieldStabilized = null;
    quote.covenants.debtYieldCovenants = null;
    quote.covenants.financialCovenantsMisc = null;
  }
};
export const setFinancialsNull = quote => {
  if (quote.details) {
    quote.details.amount = null;
    quote.details.rateTypeId = null;
    quote.details.indexId = null;
    quote.details.interestRate = null;
    quote.details.loanSpread = null;
  }
  if (quote.covenants) {
    quote.covenants.ltvStabilized = null;
    quote.covenants.ltc = null;
  }
  if (quote.closingCosts) {
    quote.closingCosts.rateLockFeeAmount = null;
  }
};
export const setGuarantyTypeNull = quote => {
  if (quote.recourse) {
    quote.recourse.guaranteeTypeId = null;
    quote.recourse.misc = null;
  }
};
export const setInterestRateProtectionNull = quote => {
  if (quote.hedgeRequirements) {
    quote.hedgeRequirements.requiredHedgeId = null;
    quote.hedgeRequirements.pricingRequirements = null;
  }
  if (quote.hedges && quote.hedges.length > 0) {
    quote.hedges.forEach(x => x.loanId = null);
  }
};
export const setOtherNull = quote => {
  quote.details.other = null;
};
export const setPrepaymentNull = quote => {
  if (quote.prepaymentTerms) {
    quote.prepaymentTerms.prepaymentTypeId = null;
    quote.prepaymentTerms.exitFee = null;
    quote.prepaymentTerms.other = null;
  }
  quote.prepaymentSchedules = [];
};
export const setReserveAccountsNull = quote => {
  if (quote.covenants) {
    quote.covenants.escrowAccountsMisc = null;
  }
};

export const shouldShowInterestRate = (defaultIndex, values) => defaultIndex == 1 && values && values.details && values.details.indexId === INTEREST_INDEXES.INTERNALLY_FIXED;
export const shouldShowLoanSpread = values => values && values.details && values.details.indexId !== INTEREST_INDEXES.INTERNALLY_FIXED;
export const shouldShowLoanSenority = values => {
  const loanType = values && get(values, "details.loanTypeId");

  return loanType === LOAN_TYPES.FANNIE_MAE || loanType === LOAN_TYPES.FREDDIE_MAC;
};
export const getFixedFloating = values => {
  const rateTypeId = get(values, "details.rateTypeId");
  const indexId = get(values, "details.indexId");
  if (rateTypeId && rateTypeId === LOAN_RATE_TYPES.FIXED && indexId !== INTEREST_INDEXES.TREASURIES && indexId !== INTEREST_INDEXES.SEMI_BOND_SWAPS) {
    return 1;
  } else if (rateTypeId && (rateTypeId === LOAN_RATE_TYPES.FLOATING || (rateTypeId === LOAN_RATE_TYPES.FIXED && (indexId === INTEREST_INDEXES.TREASURIES || indexId === INTEREST_INDEXES.SEMI_BOND_SWAPS)))) {
    return 2;
  }

  return 0;
};
